import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { MODULE_NAME } from '../../../strings'
import { LoadingStatus } from 'shared/types'
import { OAuthProviderConfig } from './oauthProviders'

interface OAuthProviderButtonProps {
  provider: OAuthProviderConfig
  disabled?: boolean
  loading?: LoadingStatus
  onClick: () => void
  // Lets styled() override the look
  className?: string
}

const OAuthProviderButton = ({
  provider,
  disabled,
  loading = LoadingStatus.Idle,
  onClick,
  className,
}: OAuthProviderButtonProps) => {
  const { t } = useTranslation(MODULE_NAME)
  const isPending = loading === LoadingStatus.Pending
  const Icon = provider.Icon

  return (
    <Button
      type="button"
      variant="outlined"
      fullWidth
      startIcon={<Icon />}
      disabled={disabled || isPending}
      onClick={onClick}
      className={className}
      sx={{
        color: 'text.primary',
        borderColor: 'grey.400',
        textTransform: 'uppercase',
      }}
    >
      {isPending ? t(provider.pendingLabelKey) : t(provider.labelKey)}
    </Button>
  )
}

export default OAuthProviderButton
